<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">{{ title }}</h4>
            <p class="category">{{ subtitle }}</p>
          </md-card-header>
          <md-card-content>
            <!-- 搜索条件 -->
            <el-row>
              <el-col :span="5">
                <el-input
                  v-model="log_params.keyword"
                  placeholder="请输入期数"
                ></el-input>
              </el-col>
              <el-col :span="6">
                <div class="block">
                  <span class="demonstration" style="margin: 0 5px"
                    >开始日期</span
                  >
                  <el-date-picker
                    v-model="log_params.start_date"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="block">
                  <span class="demonstration" style="margin: 0 5px"
                    >结束日期</span
                  >
                  <el-date-picker
                    v-model="log_params.end_date"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2">
                <el-button @click="search_log" type="primary">搜索</el-button>
              </el-col>
            </el-row>
            <!-- 表格内容 -->
            <simple-table
              table-header-color="green"
              :data="lotteryLogs"
              :fields="fields"
            ></simple-table>
          </md-card-content>
          <el-pagination
            background
            @size-change="search_log"
            @current-change="search_log"
            layout="total, sizes, prev, pager, next, jumper"
            :total="log_total"
            :page-size.sync="log_params.size"
            :current-page.sync="log_params.current"
            :page-sizes="[5, 10, 20, 50, 100]"
            style="text-align: center; padding: 20px 0;"
          >
          </el-pagination>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">{{ sec_title }}</h4>
            <p class="category">{{ sec_subtitle }}</p>
          </md-card-header>
          <md-card-content>
            <!-- 搜索条件 -->
            <el-row>
              <el-col :span="5">
                <el-input
                  v-model="result_params.keyword"
                  placeholder="请输入期数"
                ></el-input>
              </el-col>
              <el-col :span="6">
                <div class="block">
                  <span class="demonstration" style="margin: 0 5px"
                    >开始日期</span
                  >
                  <el-date-picker
                    v-model="result_params.start_date"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="block">
                  <span class="demonstration" style="margin: 0 5px"
                    >结束日期</span
                  >
                  <el-date-picker
                    v-model="result_params.end_date"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2">
                <el-button @click="search_result" type="primary"
                  >搜索</el-button
                >
              </el-col>
            </el-row>
            <!-- 表格内容 -->
            <simple-table
              table-header-color="green"
              :data="lotteryResults"
              :fields="result_fields"
            ></simple-table>
            <el-pagination
              background
              @size-change="search_result"
              @current-change="search_result"
              layout="total, sizes, prev, pager, next, jumper"
              :total="result_total"
              :page-size.sync="result_params.size"
              :current-page.sync="result_params.current"
              :page-sizes="[5, 10, 20, 50, 100]"
              style="text-align: center; padding: 20px 0;"
            >
            </el-pagination>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { SimpleTable } from "@/components";
import { getLotteryLogs, getLotteryResults } from "@/pages/lottery/lottery";
import { isEmpty } from "@/utils";

export default {
  components: {
    SimpleTable
  },
  computed: {
    month_ago: () => {
      let date = new Date();
      date.setMonth(date.getMonth() - 1);
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    }
  },
  data() {
    let self = this;
    return {
      title: "投注记录",
      subtitle: "",
      sec_title: "开奖结果",
      sec_subtitle: "",
      lotteryLogs: [],
      lotteryResults: [],
      log_params: {
        keyword: "",
        start_date: null,
        end_date: null,
        current: 1,
        size: 5
      },
      result_params: {
        keyword: "",
        start_date: null,
        end_date: null,
        current: 1,
        size: 5
      },
      log_total: 0,
      result_total: 0,
      fields: [
        { name: "期数", code: "lottery_no" },
        {
          name: "选择方案",
          code: "red",
          others: ["blue"],
          filter: self.balls_to_html,
          type: "html"
        },
        {
          name: "命中结果",
          code: "hit_red",
          others: ["hit_blue"],
          filter: self.balls_to_html,
          type: "html"
        },
        {
          name: "开奖结果",
          code: "draw_red",
          others: ["draw_blue"],
          filter: self.balls_to_html,
          type: "html"
        },
        { name: "奖金", code: "amount" },
        {
          name: "状态",
          code: "get_result",
          filter: x => (x === 1 ? "已开奖" : "待开奖")
        },
        { name: "开奖日期", code: "draw_date" },
        { name: "操作时间", code: "add_time" }
      ],
      result_fields: [
        { name: "期数", code: "lottery_no" },
        {
          name: "开奖结果",
          code: "red",
          others: ["blue"],
          filter: self.balls_to_html,
          type: "html"
        },
        { name: "开奖日期", code: "lottery_date" },
        { name: "兑奖截止", code: "expire_date" },
        { name: "一等奖", code: "first_amount" },
        { name: "二等奖", code: "second_amount" }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime());
              picker.$emit("pick", date);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "30天前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.result_params.start_date = this.month_ago;
    this.log_params.start_date = this.month_ago;
    this.search_log();
    this.search_result();
  },
  methods: {
    search_log() {
      getLotteryLogs(this.log_params).then(res => {
        this.lotteryLogs = [];
        setTimeout(() => {
          let data = res.data;
          this.$notifyMsg("查询成功");
          this.lotteryLogs = data.data;
          this.log_total = data.total;
        }, 100);
      });
    },
    search_result() {
      getLotteryResults(this.result_params).then(res => {
        this.lotteryResults = [];
        setTimeout(() => {
          let data = res.data;
          this.lotteryResults = data.data;
          this.result_total = data.total;
        }, 100);
      });
    },
    balls_to_html(reds, blues) {
      let html = this.reds_to_html(reds);
      if (!isEmpty(blues)) {
        html += this.blue_to_html(blues[0]);
      }
      return html;
    },
    reds_to_html(reds) {
      let html = "<ul class='lottery-balls'>";
      if (!isEmpty(reds)) {
        for (let red of reds) {
          html += this.ball_to_html(red, "red");
        }
      }
      return html + "</ul>";
    },
    blue_to_html(blue) {
      if (isEmpty(blue)) {
        return "";
      }
      return (
        "<ul class='lottery-balls'>" + this.ball_to_html(blue, "blue") + "</ul>"
      );
    },
    ball_to_html(ball, color) {
      return (
        '<li style="' +
        "background-image: url('" +
        require("@/assets/img/lottery/" + color + ".jpg") +
        "'); \">" +
        ball +
        "</li>"
      );
    }
  }
};
</script>
<style>
.lottery-balls {
  display: inline-block;
  padding: 0;
}
.lottery-balls > li {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 3px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  text-align: center;
  list-style-type: none;
  background-size: 20px 20px;
}
</style>
